import { createRouter, createWebHistory } from "vue-router";
import matchRoutes from "./match";
import user from "./user";
import main from "./main";
import bowling from "./bowling";

const routes = [
  ...matchRoutes, // 合并比赛相关路由
  ...user, // 合并用户相关路由
  ...main, // 合并主页相关路由
  ...bowling, // 合并保龄球相关路由
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// router.beforeEach(async (to, from, next) => {
//   // 调用checkAuthStatus函数，假设它返回一个Promise
//   store.dispatch('checkAuthStatus').then(authResult => {
//     if (authResult) {
//       // 如果验证通过，则允许路由继续
//       next();
//     } else {
//       const isLoginPage = to.path == "/wechatLogin";
//       if (isLoginPage) {
//         next();
//       }
//       else {
//         // 如果验证不通过，则重定向到登录页面
//         const appId = 'wx014c360d9c40c740';
//         const redirectUri = encodeURIComponent(window.location.href.split('#')[0]);
//         const wechatAuthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;

//         alert(wechatAuthUrl);
//         if (!to.query.code) {
//             window.location.href = wechatAuthUrl;
//           } else {
//             next();
//           }
//         //next('/wechatLogin');
//       }
//     }
//   }).catch(error => {
//     // 处理错误，比如记录日志或者显示错误消息
//     console.error('Auth check error:', error);
//     // 通常也会重定向到登录页面或者错误页面
//     next('/error');
//   });
// });

export default router;
